import { Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { FormInstance } from 'antd/lib';
import { Ref, useImperativeHandle } from 'react';

interface StatementConfirmationMessageFormProps {
  formRef: Ref<
    FormInstance<{
      STATEMENT_CONFIRMATION_MESSAGE: string;
    }>
  >;
  data: {
    STATEMENT_CONFIRMATION_MESSAGE: string | undefined;
  };
}

export default function StatementConfirmationMessageForm(
  props: StatementConfirmationMessageFormProps
) {
  const { formRef, data } = props;
  const [form] = useForm<{
    STATEMENT_CONFIRMATION_MESSAGE: string;
  }>();

  useImperativeHandle(formRef, () => form, [form]);

  return (
    <Form form={form} initialValues={data} preserve={false} layout="vertical">
      <Form.Item
        name="STATEMENT_CONFIRMATION_MESSAGE"
        label="對帳單確認訊息"
        rules={[{ required: true, message: '請輸入對帳單確認訊息' }]}
      >
        <Input.TextArea rows={10} />
      </Form.Item>
    </Form>
  );
}
